import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { useOfferContext } from '../../../context';

export const PublicationDate = () => {
  const { offer } = useOfferContext();

  const [isHovered, setHovered] = React.useState(false);

  const { added, humanizedTimedelta } = offer;

  const mouseOver = React.useCallback(() => setHovered(true), []);
  const mouseOut = React.useCallback(() => setHovered(false), []);

  return (
    <div onMouseOver={mouseOver} onMouseLeave={mouseOut}>
      <UIText2 color="text-secondary-default">{isHovered ? added : humanizedTimedelta}</UIText2>
    </div>
  );
};
